// jobtypes/form/form-fields.tsx
import React from 'react';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { FieldInput, FormCol } from 'motion-components';
import { Col } from 'react-bootstrap';
import { FieldSelectMaterial } from 'shared-pages';

type FormFieldsProps = {
  updateRecord: any;
  createRecord: any;
  deleteRecord: any;
  refetch: any;
  data: any;
  isNew: boolean;
};

type FormValues = {
  id: number | null;
  code: string;
  description: string;
  detailedDescription: string;
  chargingCode: string;
  materialId: number | null;
  isActive: boolean;
};

export const FormFields: React.FC<FormFieldsProps> = ({ data, isNew }) => {
  const { values } = useFormikContext<FormValues>();
  const { appStore } = useRootStore();
  const { t } = useTranslation();

  const canEdit = appStore.isPlatformOwner;
  const canAdd = appStore.isPlatformOwner;

  return (
    <div className="d-flex flex-row">
      {/* Left column */}
      <FormCol>
        <FieldInput
          label={t('Κωδικός')}
          name="code"
          placeholder=""
          disabled={!canEdit || (!isNew && !canEdit) || !canAdd}
        />
        <FieldInput label={t('Περιγραφή')} name="description" placeholder="" disabled={!canEdit} />
        <FieldInput
          label={t('Αναλυτική Περιγραφή')}
          name="detailedDescription"
          placeholder=""
          disabled={!canEdit}
        />
      </FormCol>

      {/* Right column */}
      <FormCol>
        <FieldInput
          label={t('Κωδικός Χρέωσης')}
          name="chargingCode"
          placeholder=""
          disabled={!canEdit}
        />
        <FieldSelectMaterial
          name="materialId"
          label={t('Υλικό')}
          defaultValues={{ data }}
          disabled={!canEdit}
        />
        {isActiveField(t, canEdit)}
      </FormCol>
    </div>
  );
};
